import API from "../configs/axiosInstance";

const getTemplates = () => {
    return API({
        url: `account-service/v1/questionnaires/templates`,
        method: 'GET'
    });
};

const getTemplate = (templateId) => {
    return API({
        url: `account-service/v1/questionnaires/templates/${templateId}`,
        method: 'GET'
    });
};

const createTemplate = (data) => {
    return API({
        url: `account-service/v1/questionnaires/templates`,
        method: 'POST',
        data
    });
};

const updateTemplate = (templateId, data) => {
    return API({
        url: `account-service/v1/questionnaires/templates/${templateId}`,
        method: 'PUT',
        data
    });
};

const deleteTemplate = (templateId) => {
    return API({
        url: `account-service/v1/questionnaires/templates/${templateId}`,
        method: 'DELETE'
    });
};

const sendQuestionnaire = (data) => {
    return API({
        url: `account-service/v1/questionnaires/send`,
        method: 'POST',
        data
    });
};

const getSubmissionsByDomain = (domainId) => {
    return API({
        url: `account-service/v1/questionnaires/submissions/domain/${domainId}`,
        method: 'GET'
    });
};

const getAllSubmissions = () => {
    return API({
        url: `account-service/v1/questionnaires/submissions`,
        method: 'GET'
    });
};

const getDomainStatistics = (domainId) => {
    return API({
        url: `account-service/v1/questionnaires/statistics/${domainId}`,
        method: 'GET'
    });
};

const getSubmissionsComparison = (domainId) => {
    return API({
        url: `account-service/v1/questionnaires/comparison/${domainId}`,
        method: 'GET'
    });
};

const getSubmissionByToken = (token) => {
    return API({
        url: `account-service/v1/public/questionnaires/${token}`,
        method: 'GET'
    });
};

const submitAnswers = (data) => {
    return API({
        url: `account-service/v1/public/questionnaires/submit`,
        method: 'POST',
        data
    });
};

const downloadAttachment = (key) => {
    return API({
        url: `account-service/v1/questionnaires/attachments/download`,
        method: 'GET',
        params: { key },
        responseType: 'blob'
    });
};

 
const getSchedulersByTemplate = (templateId) => {
    return API({
        url: `account-service/v1/questionnaires/templates/${templateId}/schedulers`,
        method: 'GET',
    });
};
 
const updateScheduler = (schedulerId, data) => {
    return API({
        url: `account-service/v1/questionnaires/schedulers/${schedulerId}`,
        method: 'PUT',
        data,
    });
};
 
const deleteScheduler = (schedulerId) => {
    return API({
        url: `account-service/v1/questionnaires/schedulers/${schedulerId}`,
        method: 'DELETE',
    });
};

const getAiEvaluation = (submissionId) => {
    return API({
        url: `account-service/v1/questionnaires/submissions/${submissionId}/ai-evaluation`,
        method: 'GET',
    });
};


const questionnaireService = {
    getTemplates,
    getTemplate,
    createTemplate,
    updateTemplate,
    deleteTemplate,
    sendQuestionnaire,
    getSubmissionsByDomain,
    getAllSubmissions,
    getDomainStatistics,
    getSubmissionsComparison,
    getSubmissionByToken,
    submitAnswers,
    downloadAttachment,
    getSchedulersByTemplate,
    updateScheduler,
    deleteScheduler,
    getAiEvaluation,
};

export default questionnaireService;